import {
  ExternalConnection,
  ID,
  LinkedItemGoal,
  TaskCalendarOverride,
  TaskCalendarOverrideWrite,
} from '@griply/types';
import {
  getTaskCalendarSyncCandidates,
  GetTaskCalendarSyncCandidatesOptions,
} from '@griply/utils';

export type GetTaskCalendarOverrideWritesOptions = {
  task: GetTaskCalendarSyncCandidatesOptions['task'];
  connections: ExternalConnection[];
  goals: LinkedItemGoal[];
  patch: Partial<TaskCalendarOverride>;
};

export const getTaskCalendarOverrideWrites = ({
  task,
  connections,
  goals,
  patch,
}: GetTaskCalendarOverrideWritesOptions): TaskCalendarOverrideWrite[] => {
  const goalsById = new Map<ID, LinkedItemGoal>(
    goals.map((goal) => [goal.id, goal]),
  );

  // Reuses the candidate resolution rather than re-deriving which connections
  // cover this task — that copy missed the all-tasks target and silently
  // dropped every override for tasks synced only through it.
  const candidateConnectionIds = new Set(
    getTaskCalendarSyncCandidates({ task, connections, goalsById }).map(
      ({ connectionId }) => connectionId,
    ),
  );

  return connections.flatMap((connection) => {
    if (!candidateConnectionIds.has(connection.id)) {
      return [];
    }

    return [
      {
        connectionId: connection.id,
        taskId: task.id,
        current: connection.settings?.taskOverrides?.[task.id] ?? {},
        patch,
      },
    ];
  });
};
